module.exports = __webpack_public_path__ + "img/logo-1.7417ea7b.png";